export const TICKET_LIST_VIEW = {
    OPEN: 'open',
    NEW: 'new',
    MINE: 'mine',
    WAITING: 'waiting',
    CRITICAL: 'critical',
    /** Open tickets past their SLA warning time — the destination of the "SLA at risk" KPI. */
    SLA_AT_RISK: 'sla-at-risk',
    /** Open tickets past their SLA due time — the destination of the "SLA breached" KPI. */
    SLA_BREACHED: 'sla-breached',
    RESOLVED: 'resolved',
    ALL: 'all',
};
export const TICKET_ACTION = {
    ASSIGN: 'assign',
    START: 'start',
    WAIT_CLIENT: 'wait-client',
    RESUME: 'resume',
    REVIEW: 'review',
    RESOLVE: 'resolve',
    CLOSE: 'close',
    REOPEN: 'reopen',
    CANCEL: 'cancel',
    CONVERT: 'convert',
    REPLY_PUBLIC: 'reply-public',
    NOTE_INTERNAL: 'note-internal',
};
//# sourceMappingURL=tickets.js.map